import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApiService from '../../services/apiService';
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
export default {
  name: 'CoreToolbar',
  props: {
    breadcrumbs: {
      type: Array,
      required: false,
      "default": function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      containerWidth: 0,
      title: null,
      newTicketCount: 0,
      feedbackDialog: false,
      dialogTitle: '',
      dialogType: 'like'
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'refreshToolbar', 'announcements', 'permissions'])), mapState('authentication', ['user', 'isImpersonating'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    shopLink: function shopLink() {
      if (this.$store.state.app.language === 'de') {
        return 'https://digimondo.iot-shop.de';
      }
      return 'https://digimondo.iot-shop.de/en';
    },
    inputValue: {
      get: function get() {
        return this.$store.state.app.drawer;
      },
      set: function set(val) {
        this.setDrawer(val);
      }
    },
    showTicketNotificationBell: function showTicketNotificationBell() {
      return this.canReadTickets && this.newTicketCount > 0;
    },
    canCreateTickets: function canCreateTickets() {
      return this.permissions['IsFmTicket.create'] || this.permissions['IsFmTicket.manage'];
    },
    canReadTickets: function canReadTickets() {
      return this.permissions['IsFmTicket.read'] || this.permissions['IsFmTicket.manage'];
    },
    canScheduleExports: function canScheduleExports() {
      return this.permissions['VirtualDevice.read'] || this.permissions['DigitalTwin.read'];
    },
    canShowBulkEditJobs: function canShowBulkEditJobs() {
      return this.permissions['all.manage'] || this.permissions['VirtualDevice.manage'] || this.permissions['VirtualDevice.write'] || this.permissions['VirtualDevice.read'];
    },
    setTop: function setTop() {
      return [this.$store.state.app.bannerHeight ? {
        top: "".concat(this.$store.state.app.bannerHeight, "px")
      } : {
        top: '0px'
      }];
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    breadcrumbsWidth: function breadcrumbsWidth() {
      // 440px is a rough estimate for the width of the other components (email-address, buttons, ...)
      // absolute min-width (on mobile, probably) is 240px
      return "".concat(Math.max(240, Math.floor(this.containerWidth - 440)), "px");
    },
    breadcrumbsItems: function breadcrumbsItems() {
      if ((this.breadcrumbs || []).length) {
        return this.breadcrumbs;
      }
      return [this.$i18n_t(this.$route.meta.i18n)];
    }
  }),
  watch: {
    refreshToolbar: function refreshToolbar() {
      this.loadTicketNotifications();
    }
  },
  mounted: function mounted() {
    this.loadTicketNotifications();
    window.addEventListener('resize', this.debouncedCalculation);
    this.debouncedCalculation();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.debouncedCalculation);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations('app', ['setDrawer', 'toggleDrawer'])), mapActions('authentication', ['logout', 'restoreOriginal'])), {}, {
    debouncedCalculation: debounce(function () {
      var currentWidth = get(this.$refs, 'toolbarContainer.$el', {}).clientWidth;
      this.containerWidth = currentWidth;
    }, 250),
    onClickBtn: function onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    onRestore: function onRestore() {
      // eslint-disable-next-line promise/catch-or-return
      this.restoreOriginal().then(function () {
        // do a whole page reload, to clear the permission "cache" (i.e. the vue-store)
        window.location.reload();
      });
    },
    onLogout: function onLogout() {
      this.logout().then(function () {
        // Slightly inconvenient to have a full page load here
        // instead of SPA transition. But after an Error Boundary
        // the router stops working, so we use location.href to
        // make sure at least logout returns to the login screen.
        window.location.href = '/#/login';
      })["catch"](function (error) {
        console.error(error);
      });
    },
    loadTicketNotifications: function loadTicketNotifications() {
      var _this = this;
      if (this.canReadTickets) {
        // fetch the count of tickets with state 'New'
        ApiService.isFmTicketsCount(this, null, [0]).then(function (data) {
          _this.newTicketCount = data;
        })["catch"](function (error) {
          console.error(error);
        });
      }
    },
    getPath: function getPath(metaObj) {
      if (metaObj && metaObj.internalHelp) {
        return '/#/help';
      } else {
        return "".concat(this.$store.state.app.docsBaseURL);
      }
    },
    openDialog: function openDialog(data) {
      this.dialogTitle = data.title;
      this.dialogType = data.type;
      this.feedbackDialog = true;
    }
  })
};